import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/@pauliescanlon/gatsby-theme-terminal/src/layouts/PageLayout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Home`}</h1>
    <p>{`This is `}<inlineCode parentName="p">{`src/pages/index.mdx`}</inlineCode></p>
    <p>{`Code snippets can themed, see `}<inlineCode parentName="p">{`gatsby-plugin-theme-ui/index.js`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`<SourceList>
  {source => (
    <ul>
      {source.map((edge, index) => {
        const {
          frontmatter: { title }
        } = edge.node;
        return <li key={index}>{title}</li>;
      })}
    </ul>
  )}
</SourceList>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      